export default __webpack_public_path__ + "static/media/vehicle-empty.6d71c5ca.svg";